<template>
    <Spinner v-if="displaySpinner" />
    <Page>
        <template #eyebrow>
            <Eyebrow icon="pi pi-id-card">Role</Eyebrow>
        </template>
        <template #title>
            <EditableTitle v-model="role" />
        </template>
        <template #controls>
            <LastChangedInfo
                v-if="role?.identity"
                :entityId="role.identity"
                :entityType="EntityType.ROLE"
            />
            <Button
                v-if="description && !description.content && isEditing"
                v-tooltip.bottom="{
                    value: 'Will generate a first draft of the description based on the context.',
                    showDelay: 100,
                }"
                class="p-button-secondary"
                icon="pi pi-sparkles"
                label="Generate first draft"
                @click="generateRoleDescription"
            />
        </template>
        <Section editable>
            <TextAppArtefact
                v-if="role?.identity && description"
                v-model="description"
                :entityId="role.identity"
                :entityType="EntityType.ROLE"
                :isEditing="isEditing"
                :stekzModel="role"
                ref="textAppArtefact"
            />
        </Section>
        <Section>
            <RoleResponsibilities v-if="role?.identity" />
        </Section>
        <Section>
            <RoleEntityRefs v-if="role?.identity" />
        </Section>
    </Page>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import EditableTitle from "@/components/EditableTitle.vue";
import Eyebrow from "@/components/Eyebrow.vue";
import LastChangedInfo from "@/components/LastChangedInfo.vue";
import Page from "@/components/Page.vue";
import RoleEntityRefs from "@/components/Roles/RoleEntityRefs.vue";
import RoleResponsibilities from "@/components/Roles/RoleResponsibilities.vue";
import Section from "@/components/Section.vue";
import TextAppArtefact from "@/components/TextAppArtefact.vue";
import { useEditManager } from "@/composables/edit-manager";
import { useGenerateDescriptionDialog } from "@/composables/generate-description";
import { useRoleManager } from "@/composables/role-manager";
import Spinner from "@/shared/Spinner.vue";
import { EntityType } from "@/stores/entity-store";

const { isEditing } = useEditManager();
const { role, isFetching, description } = useRoleManager();
const { generateContent } = useGenerateDescriptionDialog();

const displaySpinner = ref(false);

watch(isFetching, (newValue) => (displaySpinner.value = newValue), {
    immediate: true,
});

const generateRoleDescription = async () => {
    if (!role.value) {
        return;
    }
    await generateContent(
        role.value.identity,
        EntityType.ROLE,
        description.value?.updateContent.bind(description.value)
    );
};
</script>
